export const scrollToCategory = (categoryRef: React.RefObject<HTMLDivElement> | null): void => {
  if (categoryRef && categoryRef.current) {
    categoryRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}
